import {
  JORNADA_CADENCIAS,
  type JornadaCadenciaDias,
} from '@/components/Gestores/gestorJornadaUi'

type Props = {
  value: number
  onChange: (cadencia: JornadaCadenciaDias) => void
}

/** Edição de cadência — usado no painel expandido, não na linha da tabela. */
export function GestorJornadaCadenciaSelect({ value, onChange }: Props) {
  return (
    <label className='block text-xs text-text-muted'>
      Ciclo entre reuniões 1:1
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value) as JornadaCadenciaDias)}
        className='mt-1 block w-full max-w-[11rem] rounded-lg border border-border bg-bg-main px-3 py-2 text-sm font-medium text-text-primary outline-none transition-colors focus-visible:ring-2 focus-visible:ring-accent/25'
        aria-label='Ciclo entre reuniões 1:1'
      >
        {JORNADA_CADENCIAS.map((c) => (
          <option key={c} value={c}>
            A cada {c} dias
          </option>
        ))}
      </select>
      <span className='mt-1 block text-[11px] leading-snug text-text-muted'>
        Define de quanto em quanto tempo a próxima 1:1 deve ocorrer após a última registrada.
      </span>
    </label>
  )
}
